import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { EmailVerifyInput } from '../shared/email-verify-input'
import { OtpVerificationInput } from '../shared/otp-verification-input'

export function RegisterEmailForm() {
  const [email, setEmail] = useState('')
  const [isEmailCodeSent, setIsEmailCodeSent] = useState(false)

  return (
    <div className='grid gap-4'>
      {!isEmailCodeSent ? (
        <EmailVerifyInput
          email={email}
          setEmail={setEmail}
          onCodeSent={() => setIsEmailCodeSent(true)}
        />
      ) : (
        <div className='flex flex-col gap-4'>
          <OtpVerificationInput email={email} />
          <Button
            variant='link'
            size='sm'
            className='text-muted-foreground hover:text-primary mx-auto text-xs font-normal'
            onClick={() => setIsEmailCodeSent(false)}
          >
            返回修改邮箱
          </Button>
        </div>
      )}
    </div>
  )
}
